export default class AppBrowser {

  static isMobile() { 
    if( navigator.userAgent.match(/Android/i)
        || navigator.userAgent.match(/webOS/i)
        || navigator.userAgent.match(/iPhone/i)
        || navigator.userAgent.match(/iPad/i)
        || navigator.userAgent.match(/iPod/i)
        || navigator.userAgent.match(/BlackBerry/i)
        || navigator.userAgent.match(/Windows Phone/i)
    ){
       return true
     }
    else {
       return false
     }
  }

  static isDesktop() {
    return !AppBrowser.isMobile()
  }

  static openNewTab(url, fileName) {

    if (!fileName)
      fileName = "_blank"
    
    window.open(url, fileName)
    window.focus()
  }

  static scrollTop(data) {

    if (!data)
      data = {}

    $("body,html").animate({ scrollTop: data.top || 0 }, data.duration || 300)
  }
}